import { Pipe, PipeTransform } from '@angular/core';
import { kebabCase } from 'lodash';

@Pipe({name: 'kebabCase', standalone: true})
export class KebabCasePipe implements PipeTransform {

    constructor() { }

    /**
     * Kebab-case a string
     *
     * @example "Foo Bar" => "foo-bar"
     *          "fooBar" => "foo-bar"
     *          "__FOO_BAR__" => "foo-bar"
     *
     * @param value the value to transform.
     * @returns the transformed value.
     */
    transform(value: string): string {
        return kebabCase(value);
    }
}
